import { createFileRoute, redirect } from '@tanstack/react-router'

import { orgInfoQueryOptions } from '@/queries/organization'
import { selectOrgData } from '@/selectors/organization'

export const Route = createFileRoute('/_unauthenticated/accountTypeLogin')({
  loader: async ({ context: { queryClient, orgStore } }) => {
    const orgData = await queryClient.ensureQueryData(
      orgInfoQueryOptions(orgStore.getState().orgId)
    )
    const { orgInfo } = selectOrgData(orgData)
    if (!orgInfo?.login_deep_link) {
      redirect({ to: '/login', throw: true })
    }
  },
})
